import type {
  DataResponse,
  EntityTagAdd,
  EntityTagBulkAdd,
  EntityTagRemove,
  EntityTagResponse,
  PaginatedResponse,
  TagCreate,
  TagResponse,
  TagSummary,
  TagUpdate,
} from "@/types";
import { api } from "../api";

export const tagService = {
  list: (params?: { page?: number; pageSize?: number; scope?: string; teamUuid?: string; search?: string }) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.pageSize) searchParams.set("page_size", String(params.pageSize));
    if (params?.scope) searchParams.set("scope", params.scope);
    if (params?.teamUuid) searchParams.set("team_uuid", params.teamUuid);
    if (params?.search) searchParams.set("search", params.search);
    return api.get<PaginatedResponse<TagSummary>>(`/tags?${searchParams}`);
  },
  get: (tagUuid: string) => api.get<DataResponse<TagResponse>>(`/tags/${tagUuid}`),
  create: (data: TagCreate) => api.post<DataResponse<TagResponse>>("/tags", data),
  update: (tagUuid: string, data: TagUpdate) => api.put<DataResponse<TagResponse>>(`/tags/${tagUuid}`, data),
  delete: (tagUuid: string) => api.delete<{ message: string }>(`/tags/${tagUuid}`),

  // Entity tagging
  applyTag: (data: EntityTagAdd) => api.post<DataResponse<EntityTagResponse>>("/tags/apply", data),
  applyTagsBulk: (data: EntityTagBulkAdd) => api.post<DataResponse<EntityTagResponse[]>>("/tags/apply-bulk", data),
  removeTag: (data: EntityTagRemove) => api.delete<{ message: string }>("/tags/remove", data),
  listEntityTags: (entityType: string, entityId: string) =>
    api.get<DataResponse<EntityTagResponse[]>>(`/tags/entity/${entityType}/${entityId}`),
  listTaggedEntities: (tagUuid: string, entityType?: string) => {
    const searchParams = new URLSearchParams();
    if (entityType) searchParams.set("entity_type", entityType);
    return api.get<DataResponse<EntityTagResponse[]>>(`/tags/by-tag/${tagUuid}/entities?${searchParams}`);
  },
};
